module.exports = __webpack_public_path__ + "static/media/JustActMailers_9_V1-02.06ed5bfa.jpg";